import React from 'react';

import PropTypes from 'prop-types';

import { Button, Glyphicon, SponsoredText } from 'reaxl';
import { useFeatures } from 'reaxl-features';

function AlphaShowcaseSponsoredText({
    uiContext = 'inventory',
    dealerName = '',
    onHideAlpha,
}) {
    const byDealerNameText = dealerName && `Sponsored by ${dealerName}`;
    const isInventoryAlpha = uiContext === 'inventory';
    const hideAlphaLinkText = 'Hide';
    const {
        srp_alpha_suppress_button: [isAlphaSuppressEnabled],
    } = useFeatures([
        'srp_alpha_suppress_button',
    ]);

    return (
        <div
            key="alphaSponsoredText"
            className="col-xs-12 padding-0 text-size-100 margin-top-sm-4 margin-bottom-1 margin-top-xs-2"
        >
            {uiContext === 'owner' && (
                <SponsoredText />
            )}
            <div className="col-xs-10 display-flex align-items-center padding-0">
                {isInventoryAlpha && byDealerNameText}
                {uiContext === 'owner' && (
                    <div className="text-size-300 text-bold">Featured Dealer Near You</div>
                )}
            </div>
            <div className="col-xs-2 display-flex align-items-center justify-content-end padding-0 text-link link-undecorated">
                {isAlphaSuppressEnabled && (
                    <Button
                        bsStyle="text"
                        bsSize="small"
                        className="padding-0 text-size-100"
                        onClick={onHideAlpha}
                    >
                        {hideAlphaLinkText}
                        <Glyphicon
                            aria-label="remove alpha"
                            glyph="remove"
                            role="button"
                            style={{ verticalAlign: 'top' }}
                            className="text-blue text-size-300"
                        />
                    </Button>
                )}
            </div>
        </div>
    );
}

AlphaShowcaseSponsoredText.propTypes = {
    /**
     * Notifies the AlphaShowcase whether to display owner or invertory Alpha listing
     */
    uiContext: PropTypes.oneOf([
        'owner',
        'inventory',
    ]),
    /**
     * The dealer name
     */
    dealerName: PropTypes.string,
};

export default AlphaShowcaseSponsoredText;
